<template>
    <div v-if="isShowRatePreview" class="product__rating">
      <p class="rating-title">Rate this preview (Optional)</p>
      <div class="star-box" @click.stop.prevent @mouseout="rateOnHover = 0">
        <span
          class="jdgm-star"
          :class="getStarClasses(index)"
          @click="selectRate(index)"
          @mouseover="rateOnHover = index"
          v-for="index of 5"
          :key="index"
        ></span>
      </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, ref} from '@vue/reactivity'
import { onMounted, onUnmounted } from 'vue'
import EventBus from '@/services/eventbus'
import {
  EVENT_PRODUCT_SHOW_PREVIEW
} from '@/utils'
import useProductStore from '@/store/product'
import Analytics from '@/services/analytics'
const productStore = useProductStore()

const isShowRatePreview = computed(() => {
  return productStore?.product?.tags?.includes('AI_removebg') && productStore?.hasPreview && previewUrl.value
})

const rateOnHover = ref(0)
const rateMap = computed(() => productStore?.previewRateMap)
const previewUrl = ref('')
function getStarClasses(index: number) {
  const  rating =
    rateOnHover.value > 0
      ? rateOnHover.value
      : getCurrentRating()
  return rating >= index ? 'jdgm--on' : 'jdgm--off'
}

function selectRate(input: number) {
  const img = document.querySelector(
      '.ai-style-transfer-recently__item--active img'
    ) as HTMLImageElement

  if (!img) return

  const currentUrl = img.src

  Analytics.track('Rate preview AI image', {
    product_id: productStore?.product?.id,
    rating: input,
    preview_url: currentUrl
  })

  productStore.previewRateMap[currentUrl] = input
  previewUrl.value = currentUrl
}

function updatePreviewUrl() {
  const img = document.querySelector(
    '.ai-style-transfer-recently__item--active img'
  ) as HTMLImageElement

  if (img) {
    previewUrl.value = img.src
  } else {
    previewUrl.value = ''
  }
}

function getCurrentRating() {
    console.log('rateMap.value',rateMap.value)
  return rateMap.value[previewUrl.value] || 0
}

onMounted(() => {
    EventBus.on(EVENT_PRODUCT_SHOW_PREVIEW, updatePreviewUrl)
})

onUnmounted(() => {
  EventBus.off(EVENT_PRODUCT_SHOW_PREVIEW, updatePreviewUrl)
})
</script>

<style lang="scss">
.product__rating {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.product__main-slider .product__rating .rating-title {
  font-size: 20px;
  margin-bottom: 10px;
}

.product__main-slider .product__rating .jdgm-star {
  font-size: 27px;
}

.lightbox-popup__content .product__rating .rating-title {
  font-size: 16px;
  margin-bottom: 10px;
  margin-top: 0px;
}
.lightbox-popup__content .product__rating .star-box {
  margin-bottom: 10px;
}
.lightbox-popup__content .product__rating .jdgm-star {
  font-size: 20px;
}
</style>